import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface PlaceOrderInput {
    orderId: string;
    scheduledFor?: string | null;
}

const placeOrder = async (data: PlaceOrderInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/order/place`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const usePlaceOrder = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (data: PlaceOrderInput) => placeOrder(data, sessionContext?.sessionId ?? null),
        onError: (error) => {
            console.error('Failed to place order:', error);
        }
    });
};
